import { useMemo } from 'react'
import { ListSearchParams } from '../model'

export interface SearchFilterProps {
    label: string
    query: URLSearchParams
}

export const useSearchParams = <T extends ListSearchParams>(
    query: URLSearchParams
): T => {
    const search = useMemo(() => query.get('search') ?? '', [query])
    const params = useMemo(() => {
        return {
            search,
        } as T
    }, [search])

    return params
}
